/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log("[Initiate claim]...");

    const phoneTable = document.getElementById('table_responsive_2');
    if (!phoneTable) return claim;
    if (document.getElementById('phone-numbers-subheader')) return claim;

    const title = document.createElement('div');
    title.id = 'phone-numbers-subheader';
    title.className = 'h3 mb-3 formTitle mt-5';
    title.textContent = 'ADDITIONAL PHONE NUMBERS';

    const body = document.createElement('div');
    body.className = 'mb-3 formBody';
    body.textContent = 'Please list any additional phone numbers that may have been associated with your Android device.';

    phoneTable.insertAdjacentElement('beforebegin', title);
    phoneTable.insertAdjacentElement('beforebegin', body);

    const docInstructions = document.querySelector('#documentation p.fw-bold');
    if (docInstructions) {
        docInstructions.classList.remove('text-center', 'fw-bold');
    }

    return claim;
}

function disableIfPopulated(id) {
    const field = document.getElementById(id);
    field.disabled = Boolean(field.value);
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log("[Load class member]...");
    disableIfPopulated('first_name');
    disableIfPopulated('last_name');
    disableIfPopulated('email_address');
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log("[Process claim]...");
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a Non-List Class Member.
 *
 * Enforces that at least one supporting document has been uploaded before
 * allowing the claim to proceed.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaimNlcm(claim) {
    console.log("[Process NLCM claim]...");

    function uploadsFound() {
        if (claim.uploads && claim.uploads.length > 0) {
            return true;
        }
        if (
            claim.class_member.claim_files &&
            claim.class_member.claim_files.length > 0
        ) {
            return true;
        }
        return false;
    }

    if (!uploadsFound()) {
        claim.flags.valid = false;
        if (!document.getElementById('nlcm-upload-error')) {
            const alert = document.createElement('div');
            alert.id = 'nlcm-upload-error';
            alert.className = 'alert alert-danger mt-2';
            alert.setAttribute('role', 'alert');
            alert.textContent = 'Supporting documentation is required. Please upload at least one document to proceed.';
            document.getElementById('file-upload')?.insertAdjacentElement('beforebegin', alert);
        }
    }

    return claim;
}

function defaultRowsToThree(addButtonId) {
    const btn = document.getElementById(addButtonId);
    if (!btn) return;
    btn.click();
    btn.click();
}

/**
 * Custom function to load a Non-List Class Member.
 *
 * NLCM members self-report their contact information; first/last name
 * are locked only if pre-populated; email remains editable.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMemberNlcm(claim) {
    console.log("[Load NLCM class member]...");
    disableIfPopulated('first_name');
    disableIfPopulated('last_name');
    document.querySelector('#transactions_1 > caption')?.remove();
    document.querySelector('#transactions_2 > caption')?.remove();
    defaultRowsToThree('add_transactions_1');
    defaultRowsToThree('add_transactions_2');
    return claim;
}
